import { flow, head } from 'lodash';
import { createSelector } from 'reselect';
import { makeInsightsByTypeSelector, insightsLoadingSelector } from 'store/state/domainData/selectors';
import { InsightDescriptor } from 'utils/entities';
import { ILSchoolGroupsSummary } from './types';


export const ILSchoolInsightSelector = flow(
  makeInsightsByTypeSelector(InsightDescriptor.ILSchools),
  head
);

export const ilSchoolsDataSelector = createSelector([
  ILSchoolInsightSelector,
  insightsLoadingSelector,
], (insight, isLoading): ILSchoolGroupsSummary | null => {
  if (!insight || isLoading) return null;

  return insight.summary.nonText.data as ILSchoolGroupsSummary;
});

export const hasSchoolsDataSelector = createSelector([
  ilSchoolsDataSelector,
], (ilSchoolsData): boolean => Boolean(ilSchoolsData && (ilSchoolsData.ELEMENTARY.length || ilSchoolsData.HIGHSCHOOL.length)));

